export default __webpack_public_path__ + "static/media/water-4.afdeb928.jpg";